export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function toDanishOrdinal(num) {
  const number = parseInt(num);
  switch (number) {
    case 1:
      return 'første';
    case 2:
      return 'anden';
    case 3:
      return 'tredje';
    case 4:
      return 'fjerde';
    case 5:
      return 'femte';
    case 6:
      return 'sjette';
    case 7:
      return 'syvende';
    case 8:
      return 'ottende';
    case 9:
      return 'niende';
    case 10:
      return 'tiende';

    default:
      return `${num}.`;
  }
}

export function modeToDanish(mode) {
  switch (mode) {
    case 'WALK':
      return 'gå';
    case 'BICYCLE':
      return 'cykel';
    case 'RAIL':
      return 'tog';
    case 'BUS':
      return 'bus';
    default:
      return '';
  }
}

export function absoluteDirectionToDanish(absuluteDirection) {
  switch (absuluteDirection) {
    case 'NORTH':
      return 'nord';
    case 'NORTHEAST':
      return 'nordøst';
    case 'EAST':
      return 'øst';
    case 'SOUTHEAST':
      return 'sydøst';
    case 'SOUTH':
      return 'syd';
    case 'SOUTHWEST':
      return 'sydvest';
    case 'WEST':
      return 'vest';
    case 'NORTHWEST':
      return 'nordvest';
    default:
      return '';
  }
}
export function relativeDirectionToDanish(relativeDirection) {
  switch (relativeDirection) {
    case 'NORTH':
      return 'nord';
    case 'DEPART':
      return 'start';
    case 'HARD_LEFT':
      return 'skarpt til venstre';
    case 'LEFT':
      return 'venstre';
    case 'SLIGHTLY_LEFT':
      return 'svagt til venstre';
    case 'CONTINUE':
      return 'fortsæt';
    case 'SLIGHTLY_RIGHT':
      return 'svagt til højre';
    case 'RIGHT':
      return 'højre';
    case 'HARD_RIGHT':
      return 'skarpt til højre';
    case 'CIRCLE_CLOCKWISE':
      return 'tag rundkørslen';
    case 'CIRCLE_COUNTERCLOCKWISE':
      return 'tag rundkørslen';
    case 'ELEVATOR':
      return 'elevator';
    case 'UTURN_LEFT':
      return 'uvending mod venstre';
    case 'UTURN_RIGHT':
      return 'uvending mod højre';
    default:
      return '';
  }
}

export function getPlaceVejnavn(place) {
  if (!place) {
    return '';
  }
  if (place.title) {
    return place.title;
  }
  const { postnummer } = place.adgangsAdresse;
  return `${place.adgangsAdresse.vejstykke.adresseringsnavn} ${
    place.adgangsAdresse.husnr
  }, ${postnummer.nr} ${postnummer.navn}`;
}

export function copyToClipBoard(value) {
  const element = document.createElement('textarea');
  element.value = value;
  document.body.appendChild(element);
  // element.focus();
  element.select();
  element.setSelectionRange(0, element.value.length);
  document.execCommand('copy');
  document.body.removeChild(element);
}

export function getDistanceString(distance) {
  const meters = parseInt(distance);
  if (meters > 999) {
    let kilometers = parseInt(meters / 1000);
    const remainingMeters = meters % 1000;
    if (kilometers < 10 && remainingMeters > 99) {
      kilometers = `${kilometers},${parseInt(remainingMeters / 100)}`;
    }
    return `${kilometers} km`;
  }
  return `${meters} m`;
}
